<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- titulo y boton crear -->
    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col cols="12" class="d-flex justify-end align-center">
        <TableButtonComp
          normalButton
          text-button="Crear Nivel"
          icon-but="fas fa-plus"
          @click="addItem"
        />
      </v-col>
    </v-row>

    <v-row>
      <template>
        <v-container fluid>
          <v-data-iterator
            :items="Niveles"
            :items-per-page.sync="itemsPerPage"
            :page.sync="page"
            :search="search"
            elevation="2"
            hide-default-footer
          >
            <template v-slot:header>
              <v-row dense>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp
                    @change="getNivelesPais(id_pais_search)"
                    v-model="id_pais_search"
                    autoSelectFirst
                    textLabel="País"
                    :items="paisFiltro"
                    item-value="id"
                    item-text="nombre_pais"
                  />
                </v-col>
                <v-col cols="12" md="8" sm="6" class="d-flex justify-end">
                  <v-text-field
                    v-model="search"
                    style="max-width: 400px"
                    clearable
                    placeholder="Buscar nivel"
                    dense
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-slot:default="props">
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  class="d-flex justify-center"
                  v-for="item in props.items"
                  :key="item.id"
                >
                  <v-card :color="item.color" width="250" dark elevation="7">
                    <v-list-item>
                      <v-list-item-content>
                        <span class="mb-1">
                          <h3>{{ item.desc_nivel }}</h3>
                        </span>
                        <span class="mb-1">
                          <h5>{{ item.nombre_pais }}</h5>
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider />
                    <v-card-actions class="white">
                      <v-row>
                        <v-col cols="8" class="d-flex justify-center">
                          <TableButtonComp
                            v-if="componenteEvento.visualizar_submodulo"
                            text-button="Ver Grados"
                            icon-but="fas fa-eye"
                            @click="getAllGradosNivel(item)"
                          />
                        </v-col>
                        <!--MOLDAL DE EDITAR NIVEL -->
                        <v-col
                          cols="4"
                          class="d-flex justify-center align-center gap-10px"
                        >
                          <TableButtonComp
                            editButton
                            v-if="componenteEvento.editar_submodulo"
                            @click="editItem(item)"
                            tooltipText="Editar nivel"
                          />

                          <TableButtonComp
                            v-if="componenteEvento.borrar_submodulo"
                            @click="deleteConfirm(item)"
                            deleteButton
                            tooltipText="Eliminar nivel"
                          />
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-slot:footer>
              <v-row class="elevation-1">
                <v-col cols="12" class="d-flex align-center">
                  <span class="grey--text">Niveles por página:</span>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        text
                        color="primary"
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ itemsPerPage }}
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(number, index) in itemsPerPageArray"
                        :key="index"
                        @click="updateItemsPerPage(number)"
                      >
                        <v-list-item-title>{{ number }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-spacer></v-spacer>

                  <span class="mr-4 grey--text">
                    Página {{ page }} de {{ numberOfPages }}
                  </span>
                  <v-btn
                    dark
                    icon
                    color="primary"
                    class="mr-1"
                    @click="formerPage"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    dark
                    icon
                    color="primary"
                    class="ml-1"
                    @click="nextPage"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-container>
      </template>
    </v-row>

    <!-- MODAL CREAR NIVEL--->

    <v-container>
      <v-form ref="formDatos" lazy-validation>
        <v-dialog v-model="dialog" scrollable persistent max-width="350">
          <v-card>
            <v-card-title class="btn_otro pt-4">
              <label>{{ formTitle }}</label>
              <v-spacer />
              <v-btn fab dark x-small class="btn_style3" @click="dialog = false">
                <v-icon dark>fa-times</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pt-5">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    label="País"
                    :items="pais"
                    item-value="id"
                    v-model="editedItem.id_pais"
                    item-text="nombre_pais"
                    autocomplete="off"
                    :rules="[rul.selectReq]"
                    :readonly="bloquearCampo"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field
                    v-model="editedItem.desc_nivel"
                    label="Nombre"
                    autocomplete="off"
                    :rules="[rul.required, rul.max100]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-2">
                  <v-row>
                    <v-col class="">
                      <h3 class="text mb-2" style="font-weight: 400">Seleccionar color:</h3>
                    </v-col>
                  </v-row>

                  <v-color-picker
                    v-model="editedItem.color"
                    width="350px"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                class="btn_block_style2"
                :style="{ color: '#ffffff' }"
                
                v-if="this.evento == 'editar'"
                :disabled="bloquearBotonGurdar"
                @click="editNivel(editedItem.id)"
                >Guardar Cambios</v-btn
              >
              <v-btn
                class="btn_block_style2"
                :style="{ color: '#ffffff' }"
                
                v-if="this.evento == 'agregar'"
                :disabled="bloquearBotonGurdar"
                @click="addNivel"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-container>

    <!-- modal VER grados aqui-->
    <v-dialog v-model="dialog2" scrollable max-width="500">
      <v-card>
        <v-card-title class="btn_otro mt-0" width="50">
          <v-row>
            <v-col cols="10">
              Grados del nivel:
              <v-chip color="blue" class="white--text" label>
                {{ this.titleVerGrado }}
              </v-chip>
            </v-col>
            <v-col cols="2">
              <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="dialog2 = false"
              >
                <v-icon dark class="py-2">fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text>
          <div v-if="Grados_nivel.length > 0">
            <v-col cols="12" v-for="item of Grados_nivel" :key="item.id">
              <v-row align="center" class="spacer" no-gutters>
                <v-col cols="1">
                  <v-icon color="primary">fa-check</v-icon>
                </v-col>
                <v-col>
                  <v-chip
                    color="yellow lighten-4"
                    class="ml-2 black--text"
                    label
                    small
                  >
                    <h3>{{ item.desc_grado }}</h3>
                  </v-chip>
                </v-col>
                <v-col cols="6" class="pl-1 text-right">
                  <v-tooltip bottom color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="componenteEvento.editar_submodulo"
                        v-on="on"
                        class="btn_editar mx-2"
                        fab
                        x-small
                        @click="editedItemGrado(item)"
                      >
                        <v-icon>fa-pencil-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>EDITAR GRADO</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-divider />
            </v-col>
          </div>

          <div v-else class="pt-2">
            <v-alert dense border="left" type="warning">
              <strong>No hay grados registrados en este Nivel</strong>
            </v-alert>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="btn_block_style2"
            dark
            
            @click="agregarGrado()"
            v-if="componenteEvento.agregar_submodulo"
            >Agregar Grado</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--modal agregar editar grados de nivel-->
    <v-form ref="formDatosGrado" lazy-validation>
      <v-dialog v-model="modal_grado" scrollable persistent max-width="500px">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row>
              <v-col cols="10">
                {{ formTitle2 }}
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <v-btn
                  fab
                  dark
                  x-small
                  class="btn_style3"
                  @click="modal_grado = false"
                  ><v-icon dark>fa-times</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-text-field
              label="Nombre"
              v-model="newgrado.desc_grado"
              :rules="[rul.required, rul.max100]"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento2 == 'editar'"
              @click="editGrado(newgrado.id)"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              dark
              
              v-if="this.evento2 == 'agregar'"
              @click="addGrado"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!--------fin modal agregar grados a nivel-->

    <!-- /////////////////////////////////////////////////////    -->
    <v-dialog v-model="dialog_delete" width="470">
      <v-card>
        <v-card-title class="btn_ver">
          <div class="mr-15">
            Eliminar nivel
          </div>
          <v-spacer></v-spacer>
              <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="dialog_delete = false"
                ><v-icon dark>fa-times</v-icon></v-btn
              >
        </v-card-title>

        <v-card-text class="text-center black--text pt-7">
          <h3 class="">
            ¿Está seguro de que desea borrar este registro?
          </h3>
          <br>
          <p class="subtitle-1">
            {{ name_delete }}
          </p>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark  @click="dialog_delete = false"
            >No</v-btn
          >
          <v-btn class="btn_block_style2" dark  @click="deleteNivel"
            >Sí</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar registro -->
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";

export default {
  name: "niveles",
  components: {
    TableButtonComp,
    AutocompleteComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 4, id_modulo: 4 },

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    itemsPerPageArray: [4, 8, 12],
    search: "",
    page: 1,
    itemsPerPage: 4,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },

    paisFiltro: [],
    bloquearBotonGurdar: false,

    // modal agregar y editar nivel
    editedItem: [],
    dialog: false,
    evento: "",
    pais: [],
    id_pais_search: null, //id=null Todos los paises
    Niveles: [],
    bloquearCampo: false,

    // modal ver grados del nivel
    titleVerGrado: "",
    Grados_nivel: [],
    dialog2: false,

    // modal agregar editar grados del nivel
    modal_grado: false,
    evento2: "",
    newgrado: { id_nivel: 0, desc_grado: "", id_colegio: 0, estado: 1 },

    // modal eliminar nivel
    dialog_delete: false,
    name_delete: "",
    id_delete: "",
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear nivel" : "Editar nivel";
    },

    formTitle2() {
      return this.evento2 === "agregar" ? "Crear grado" : "Editar grado";
    },

    ...mapState({
      Grados: (state) => state.nivelesGrados.grados,
      // Niveles: state => state.nivelesGrados.niveles
    }),

    // creacion del dataiterator de los cards

    numberOfPages() {
      return Math.ceil(this.Niveles.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== "Name");
    },
  },

  created() {
    //this.$store.dispatch('nivelesGrados/getAllNiveles'),
    this.$store.dispatch("nivelesGrados/getAllGrados");
    this.actualizarParamentro();
    this.getPais();
    this.getNivelesPais(null);
    //this.getAllNiveles();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ...mapActions("nivelesGrados", ["getAllNiveles"]),

    ///*******  traer todos los niveles *********/
    /* async getAllNiveles(){
                    this.id_pais_search = null
    
                    try{
                        const response = await axios.get("/manager/nivelCkOne/");
                        this.Niveles = response.data;
                       // console.log(JSON.stringify(this.Niveles));
                    }
    
                    catch(error){
                         this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }
                }, */

    //-----------obtener paises----------------------------
    async getPais() {
      try {
        let response = await axios.get(
          "/mantenimiento/paises/paisesConfigurados/"
        );

        this.pais = response.data;
        let objectNew = JSON.parse(JSON.stringify(response.data));

        objectNew.unshift({
          id: null,
          nombre_pais: "TODOS",
        });

        this.paisFiltro = objectNew;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //************funcion change del filtro pais, traer nieveles por pais ******/
    async getNivelesPais(id) {
      try {
        const response = await axios.get("/manager/nivelCkOne/pais/" + id);
        this.Niveles = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //************ limpiar formulario de agregar nivel ******/
    async limpiarForm() {
      this.editedItem = {
        desc_nivel: "",
        id_usuario: this.datoLogin.id, //18-02-2020. Robert. Se vincula con el usuario en session.
        id_colegio: 0, //18-02-2020. Robert. Se setea colegio 0 por ser manager.
        color: "#0277BD",
        estado: 1,
        ck1: true,
      };

      this.bloquearCampo = false;
      this.name_delete = "";
      this.id_delete = "";

      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
      this.$refs.formDatosGrado.resetValidation();
    },

    //*************  modal agregar nilvel ***********////
    addItem() {
      this.bloquearBotonGurdar = false;
      this.evento = "agregar";
      this.dialog = true;
      this.limpiarForm();
    },

    //-----------crear Nivel modal--------------
    async addNivel() {
      if (this.$refs.formDatos.validate()) {
        this.bloquearBotonGurdar = true;
        let params = this.editedItem;

        try {
          let res = await axios.post("/manager/nivelCkOne/", params);

          if (res.data.messageT == "S") {
            this.getNivelesPais(this.id_pais_search);
            this.$store.dispatch("nivelesGrados/getAllGrados");
            this.dialog = false;
            this.limpiarForm();
          }

          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
        } catch (e) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    //---------obtener datos para editar
    editItem(item) {
      this.bloquearBotonGurdar = false;
      this.limpiarForm();
      this.evento = "editar";

      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      this.bloquearCampo = true;
    },

    //--------------editar Nivel--------------
    async editNivel(id) {
      let params = this.editedItem;
      if (this.$refs.formDatos.validate()) {
        this.bloquearBotonGurdar = true;
        try {
          let res = await axios.put("/manager/nivelCkOne/" + id, params);

          if (res.data.messageT == "S") {
            this.getNivelesPais(this.id_pais_search);
            this.dialog = false;
            this.limpiarForm();
          }

          this.bloquearBotonGurdar = false;
          this.setEnviarMens({
            tipo: res.data.messageT,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });
        } catch (e) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    //------------borrar nivel -------------
    deleteConfirm(nivel) {
      this.dialog_delete = true;
      this.id_delete = nivel.id;
      this.name_delete = `Nivel: ${nivel.desc_nivel} - ${nivel.nombre_pais}`;
    },

    async deleteNivel() {
      try {
        let resp = await axios.delete("/manager/nivelCkOne/" + this.id_delete);
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });

        if (resp.data.messageT == "S") {
          this.getNivelesPais(this.id_pais_search);
          // Comentario, el el metdodo addNivel despues de recibir una confirmacion (S) se llama un metodo del store.js
          // Tal vez necesite aplicarse acá dependiendo del caso
        }
        this.dialog_delete = false;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //-----------MODAL VER GRADOS DEL NIVEL --------------------------
    async getAllGradosNivel(nivel) {
      this.newgrado.id_nivel = nivel.id;
      this.newgrado.id_pais = nivel.id_pais;
      this.titleVerGrado = nivel.desc_nivel;
      //console.log(this.newgrado);

      try {
        let response = await axios.get(
          "/manager/gradoCkOne/grados/" + nivel.id + ""
        );
        this.Grados_nivel = response.data;
        this.dialog2 = true;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async limpiarFormGrados() {
      this.newgrado.desc_grado = "";
      (this.newgrado.id_usuario = this.datoLogin.id), //18-02-2020. Robert. Se vincula con el usuario en session.
        this.resetValidation();
    },

    // modal agregar grados desde pestaña niveles
    agregarGrado() {
      this.limpiarFormGrados();
      this.modal_grado = true;
      this.evento2 = "agregar";
    },

    async addGrado() {
      if (this.$refs.formDatosGrado.validate()) {
        let params = this.newgrado;
        try {
          let response = await axios.post("/manager/gradoCkOne/", params);
          await this.getGradosNivelAll(params.id_nivel);
          this.modal_grado = false;
          this.getAllGrados();
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
          //this.enviarMensaje(response.data.message, response.data.mti, 6000)
          this.limpiarFormGrados();
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      }
    },

    editedItemGrado(item) {
      this.limpiarFormGrados();
      this.modal_grado = true;
      this.evento2 = "editar";
      this.newgrado = Object.assign({}, item);
    },

    //--------------editar grado--------------
    async editGrado(id) {
      let params = this.newgrado;
      if (this.$refs.formDatosGrado.validate()) {
        try {
          let response = await axios.put("/manager/gradoCkOne/" + id, params);
          await this.getGradosNivelAll(params.id_nivel);
          this.modal_grado = false;
          this.getAllGrados();
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          //console.log(error);
        }
      }
    },

    async getGradosNivelAll(id) {
      try {
        const response = await axios.get(
          "/manager/gradoCkOne/grados/" + id + ""
        );
        this.Grados_nivel = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    // funcion que trae todos los grados creados, esta ubicada en NivelesyGrados.vue
    getAllGrados() {
      this.$emit("getAllGradosNiveles");
    },

    // Methodos en duncion del dataIterator
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
  },
};
</script>
